import {Separator} from 'platform/components';
import {Box, HStack, Show, VStack} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';
import {SkeletonLoadingBox} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

const SKELETON_BACKGROUND_COLOR = 'palettes.neutral.30.100' as const;
const FLAGS = [
  {key: 'first', width: 28},
  {key: 'second', width: 36},
  {key: 'third', width: 24},
  {key: 'fourth', width: 32},
  {key: 'fifth', width: 20},
  {key: 'sixth', width: 40},
] as const;
const PREMIUM_FLAGS = [
  {key: 'first', width: 32},
  {key: 'second', width: 24},
  {key: 'third', width: 28},
] as const;

export function FeatureMarketAnalysisCardSkeleton(props: TestIdProps) {
  return (
    <VStack spacing={3} data-testid={suffixTestId('skeleton', props)}>
      <Show whenFeatureEnabled={featureFlags.SALES_FEATURE_SCORING}>
        <VStack spacing={3}>
          <SkeletonLoadingBox
            isLoading
            width={40}
            height={4}
            backgroundColor={SKELETON_BACKGROUND_COLOR}
          />
          <SkeletonLoadingBox isLoading height={3} backgroundColor={SKELETON_BACKGROUND_COLOR} />
          <SkeletonLoadingBox
            isLoading
            width={20}
            height={8}
            backgroundColor={SKELETON_BACKGROUND_COLOR}
          />
          <Separator />
        </VStack>
      </Show>
      <Show whenFeatureEnabled={featureFlags.VEHICLE_PREMIUM_FEATURES}>
        <VStack spacing={3}>
          <SkeletonLoadingBox
            isLoading
            width={24}
            height={4}
            backgroundColor={SKELETON_BACKGROUND_COLOR}
          />
          <SkeletonLoadingBox isLoading height={3} backgroundColor={SKELETON_BACKGROUND_COLOR} />
          <HStack spacing={2} wrap>
            {PREMIUM_FLAGS.map((flag) => (
              <Box key={flag.key}>
                <SkeletonLoadingBox
                  isLoading
                  width={flag.width}
                  height={6}
                  borderRadius="small"
                  backgroundColor={SKELETON_BACKGROUND_COLOR}
                />
              </Box>
            ))}
          </HStack>
          <Separator />
        </VStack>
      </Show>
      <SkeletonLoadingBox
        isLoading
        width={32}
        height={4}
        backgroundColor={SKELETON_BACKGROUND_COLOR}
      />
      <SkeletonLoadingBox isLoading height={3} backgroundColor={SKELETON_BACKGROUND_COLOR} />
      <HStack spacing={2} wrap>
        {FLAGS.map((flag) => (
          <Box key={flag.key}>
            <SkeletonLoadingBox
              isLoading
              width={flag.width}
              height={6}
              borderRadius="small"
              backgroundColor={SKELETON_BACKGROUND_COLOR}
            />
          </Box>
        ))}
      </HStack>
    </VStack>
  );
}
